// extracted by mini-css-extract-plugin
export var introduce = "index-module--introduce--tDSwu";